import Workload from './workload';

export default class ReplicaSet extends Workload {
}
